import { render, staticRenderFns } from "./PDFInvoice.vue?vue&type=template&id=3c504ad8&scoped=true&"
import script from "./PDFInvoice.vue?vue&type=script&lang=js&"
export * from "./PDFInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PDFInvoice.vue?vue&type=style&index=0&id=3c504ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c504ad8",
  null
  
)

export default component.exports